import axios from "../../../config/axiosConfig";

export const getReporteFacturasTotal = ({ sucursal, year, mes, preFac }) =>
  axios.get("/api/reporte-facturas", { params: { sucursal, year, mes, preFac } });

export const exportarReporteFacturasTotal = ({ sucursal, year, mes, preFac }) =>
  axios.get("/api/reporte-facturas/exportar", {
    params: { sucursal, year, mes, preFac },
    responseType: "blob",
  });

export const getReportePorAnio = ({ sucursal, year }) =>
  axios.get("/api/reporte-facturas/por-anio", { params: { sucursal, year } });

export const getDetalleMesServicio = ({ sucursal, year, mes, categoria }) =>
  axios.get("/api/reporte-facturas/detalle-mes-servicio", { params: { sucursal, year, mes, categoria } });

export const getReportePorAnioMes = ({ year }) =>
  axios.get("/api/reporte-facturas/por-anio-mes", { params: { year } });

export const getDetallePorCodigos = (cods) =>
  axios.post("/api/reporte-facturas/detalle-por-codigos", { cods });

export const getReporteFacturasMora = ({ sucursal }) =>
  axios.get("/api/reporte-facturas/mora", { params: { sucursal } });

export const exportarReporteFacturasMora = ({ sucursal }) =>
  axios.get("/api/reporte-facturas/mora/exportar", { params: { sucursal }, responseType: "blob" });

// Detalle interno (conceptos internos y su reparto en líneas fiscales): suma de la línea de % alto
export const getReporteDetalleInterno = ({ sucursal, year, mes, preFac, incluirAnuladas, codServicio }) =>
  axios.get("/api/reporte-facturas/detalle-interno", { params: { sucursal, year, mes, preFac, incluirAnuladas, cod_servicio: codServicio || undefined } });

// Facturas repartidas por código de producción (los datos de /facturacion-admin)
export const getReportePorCodigo = ({ sucursal, year, mes, preFac }) =>
  axios.get("/api/reporte-facturas/por-codigo", { params: { sucursal, year, mes, preFac } });
